import { c as _c } from "react/compiler-runtime";
import { Button } from '@module/mdrt-org/shared/components/button/button';
import { type CustomerProfile } from '@module/mdrt-org/shared/utils/types/customer-profile';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';
import { GTM_ACTION_DOWNLOAD, GTM_EVENT_NAME_PDF_DOWNLOAD } from '@shared/utils/constants/gtm';
import { useFormatTranslationString } from '@shared/utils/helpers/format-translation-string';
import { sendGtmEvent } from '@shared/utils/helpers/send-gtm-event';
import { type AccountSettingsProfileContent } from '../get-account-settings-profile-content';
import styles from './membership-printouts.module.scss';
type MembershipPrintoutsProps = {
  cmsContent: AccountSettingsProfileContent;
  customerProfile: CustomerProfile;
  isPrintoutsVisible: boolean;
  membershipCertificateEndpointUrl: string;
};
export const MembershipPrintouts = t0 => {
  const $ = _c(20);
  const {
    cmsContent,
    customerProfile,
    isPrintoutsVisible,
    membershipCertificateEndpointUrl
  } = t0;
  const formatTranslationString = useFormatTranslationString();
  const membershipYear = customerProfile.lastYearOfMembership;
  if (!isPrintoutsVisible) {
    return null;
  }
  let t1;
  if ($[0] !== membershipCertificateEndpointUrl || $[1] !== membershipYear) {
    t1 = () => {
      window.open(membershipCertificateEndpointUrl, "_blank");
      sendGtmEvent({
        action: GTM_ACTION_DOWNLOAD,
        eventName: GTM_EVENT_NAME_PDF_DOWNLOAD,
        label: `${membershipYear} Membership Certificate`
      });
    };
    $[0] = membershipCertificateEndpointUrl;
    $[1] = membershipYear;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== cmsContent.membershipPrintouts.getMembershipCertificateLabelTemplate || $[4] !== formatTranslationString || $[5] !== membershipYear) {
    t2 = formatTranslationString(cmsContent.membershipPrintouts.getMembershipCertificateLabelTemplate, {
      year: membershipYear
    });
    $[3] = cmsContent.membershipPrintouts.getMembershipCertificateLabelTemplate;
    $[4] = formatTranslationString;
    $[5] = membershipYear;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <Button className={styles.container__button} onClick={t1} role="link">{t2}</Button>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = cmsContent.membershipPrintouts.pagePaths.accountSettingPagePath;
  let t5;
  if ($[10] !== cmsContent.membershipPrintouts.viewMembershipInvoiceLabelTemplate || $[11] !== formatTranslationString || $[12] !== membershipYear) {
    t5 = formatTranslationString(cmsContent.membershipPrintouts.viewMembershipInvoiceLabelTemplate, {
      year: membershipYear
    });
    $[10] = cmsContent.membershipPrintouts.viewMembershipInvoiceLabelTemplate;
    $[11] = formatTranslationString;
    $[12] = membershipYear;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== cmsContent.membershipPrintouts.pagePaths.accountSettingPagePath || $[15] !== t5) {
    t6 = <Button isSmall={true} to={t4} variant={ButtonVariant.Tertiary}>{t5}</Button>;
    $[14] = cmsContent.membershipPrintouts.pagePaths.accountSettingPagePath;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t3 || $[18] !== t6) {
    t7 = <div className={styles.container}>{t3}{t6}</div>;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};